export default function appendIfNotNull(array, element) {
    if (element !== null) {
        array.push(element);
    }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts/dist/es/chart/utils/append-if-not-null.js
// module id = 2400
// module chunks = 29